import { TranslationKeys } from '../es';
import { general } from './general';
import { navigation } from './navigation';
import { product } from './products';
import { subscription } from './subscription';
import { suggestedPrice } from './suggestedPrice';
import { taxProfile } from './taxProfile';
import { userAccount } from './userAccount';

const en: TranslationKeys = {
  ...navigation,
  ...general,
  ...product,
  ...userAccount,
  ...subscription,
  ...suggestedPrice,
  ...taxProfile,
};

export default en;
